import { useEffect } from 'react';
import { useLocation } from 'react-router';

// 非同期で読み込まれる設定も待ち、折りたたまれた親を開いてから場所を示す。
export function SearchFocus() {
  const location = useLocation();
  useEffect(() => {
    const focus = new URLSearchParams(location.search).get('focus');
    if (!focus) return;
    let highlighted: HTMLElement | undefined;
    let clear: ReturnType<typeof setTimeout> | undefined;
    let scroll: ReturnType<typeof setTimeout> | undefined;
    const reveal = (element: HTMLElement) => {
      for (const ancestor of [element, ...parents(element)]) {
        if (ancestor.hidden) {
          const toggle = ancestor.parentElement?.querySelector<HTMLButtonElement>('[aria-expanded="false"]');
          toggle?.click();
        }
      }
      scroll = setTimeout(() => {
        element.scrollIntoView?.({ block: 'center', behavior: 'smooth' });
      }, 0);
      element.classList.add('search-highlight');
      highlighted = element;
      clear = setTimeout(() => element.classList.remove('search-highlight'), 2200);
    };
    const find = () => {
      const target = Array.from(document.querySelectorAll<HTMLElement>('[data-search-id]')).find(
        (item) => item.dataset.searchId === focus,
      );
      if (!target) return false;
      observer.disconnect();
      reveal(target);
      return true;
    };
    const observer = new MutationObserver(() => {
      find();
    });
    observer.observe(document.body, { childList: true, subtree: true });
    find();
    const fallback = setTimeout(() => {
      observer.disconnect();
      if (!highlighted) {
        const target =
          document.querySelector<HTMLElement>('[data-search-section]') ??
          document.querySelector<HTMLElement>('#server-panel') ??
          document.querySelector<HTMLElement>('main');
        if (target) reveal(target);
      }
    }, 5000);
    return () => {
      observer.disconnect();
      clearTimeout(fallback);
      clearTimeout(clear);
      clearTimeout(scroll);
      highlighted?.classList.remove('search-highlight');
    };
  }, [location]);
  return null;
}

function parents(element: HTMLElement): HTMLElement[] {
  const result: HTMLElement[] = [];
  let parent = element.parentElement;
  while (parent) {
    result.push(parent);
    parent = parent.parentElement;
  }
  return result;
}
